import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M15.179 6.768c-1.87-.393-3.323-1.885-3.71-3.785-.015-.094-.092-.157-.2-.157-.093 0-.17.062-.201.157-.386 1.9-1.855 3.392-3.71 3.785-.092.015-.154.094-.154.204 0 .094.062.172.155.204 1.87.393 3.322 1.884 3.709 3.769.015.094.093.157.2.157.093 0 .17-.063.202-.157a4.825 4.825 0 0 1 3.709-3.77c.093-.015.155-.093.155-.203 0-.11-.062-.189-.155-.204Zm-6.228 4.428C7.452 10.882 6.277 9.69 5.968 8.15a.151.151 0 0 0-.154-.126.151.151 0 0 0-.155.126c-.309 1.539-1.484 2.732-2.983 3.046-.077.016-.123.079-.123.157 0 .079.046.142.123.157a3.872 3.872 0 0 1 2.983 3.031.151.151 0 0 0 .155.126.15.15 0 0 0 .154-.126 3.872 3.872 0 0 1 2.983-3.03c.077-.016.124-.08.124-.158s-.047-.141-.124-.157ZM3.619 7.6c.03.094.108.157.2.157.094 0 .186-.063.202-.157.324-1.398 1.437-2.513 2.797-2.843a.216.216 0 0 0 .155-.204c0-.094-.062-.188-.155-.204A3.816 3.816 0 0 1 4.021 1.49c-.016-.095-.108-.158-.201-.158-.093 0-.186.063-.201.158-.34 1.413-1.407 2.512-2.797 2.858a.216.216 0 0 0-.155.204c0 .094.062.188.155.204 1.36.33 2.457 1.445 2.797 2.843Z"
    }
  )
);
var SvgSparklesFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var SparklesFilled_default = SvgSparklesFilled;

export { SparklesFilled_default as default };
